import { Facebook, Twitter, Linkedin, Youtube, Phone, Mail, Calendar, ArrowUp } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.webp";
const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-dark text-light pt-5">
      {/* Main Footer Content */}
      <div className="container">
        <div className="row g-4">
          {/* Brand Section */}
          <div className="col-12 col-md-6 col-lg-3">
            <div className="d-flex align-items-center mb-3">
              <div
              
                style={{ width: "40px", height: "40px" }}
              >
                <span> {/* Brand / Logo */}
                        <Link to="/" className="navbar-brand d-flex align-items-center text-light fw-bold fs-3">
                  <img
                    src={logo}
                    alt="Logo"
                    style={{ height: "40px", width: "40px", marginRight: "10px", borderRadius: "50%" }}
                  />
                 
                </Link></span>
              </div>
              <span className="fs-4 fw-bold">FindMe</span>
            </div>
            <p className="small mb-3">
              Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis
            </p>
            <div className="d-flex gap-2">
              {[Facebook, Twitter, Linkedin, Youtube].map((Icon, i) => (
                <Link
                  key={i}
                  to="/"
                  className="btn btn-outline-light btn-sm rounded-circle p-2"
                >
                  <Icon size={16} />
                </Link>
              ))}
            </div>
          </div>

          {/* Our Services */}
          <div className="col-12 col-md-6 col-lg-3">
            <h5 className="mb-3">Our Services</h5>
            <ul className="list-unstyled small">
              {[
                "Office Cleaning",
                "House Cleaning",
                "Kitchen Cleaning",
                "Washroom Cleaning",
                "Carpet Cleaning",
              ].map((item, i) => (
                <li key={i}>
                  <Link
                    to={`/services/${item.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-light text-decoration-none d-block mb-1"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div className="col-12 col-md-6 col-lg-3">
            <h5 className="mb-3">Quick Links</h5>
            <div className="row">
              <div className="col-6">
                {["About Us", "Services", "Portfolio", "Expert Team", "FAQ"].map((link, i) => (
                  <Link
                    key={i}
                    to={`/${link.toLowerCase().replace(/\s+/g, "-")}`}
                    className="d-block text-light mb-1 text-decoration-none"
                  >
                    {link}
                  </Link>
                ))}
              </div>
              <div className="col-6">
                {["Error", "News Blog", "Contact Us", "Testimonial"].map((link, i) => (
                  <Link
                    key={i}
                    to={`/${link.toLowerCase().replace(/\s+/g, "-")}`}
                    className="d-block text-light mb-1 text-decoration-none"
                  >
                    {link}
                  </Link>
                ))}
              </div>
            </div>
          </div>

          {/* Popular Post */}
          <div className="col-12 col-md-6 col-lg-3">
            <h5 className="mb-3">Popular Post</h5>
            {[
              {
                title: "My home cleaned My way.",
                date: "03, Mar 2025",
              },
              {
                title: "Your clean home is Our business.",
                date: "01, Mar 2025",
              },
            ].map((post, i) => (
              <div key={i} className="d-flex mb-3">
                <div
                  className="bg-warning rounded me-2"
                  style={{ width: "60px", height: "60px" }}
                ></div>
                <div>
                  <h6 className="mb-1 small">{post.title}</h6>
                  <div className="d-flex align-items-center gap-1 text-warning small">
                    <Calendar size={12} />
                    <span>{post.date}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Contact Bar */}
      <div className="bg-secondary text-light py-4 mt-4">
        <div className="container d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">
          <h6 className="mb-0">Don't hesitate Contact With Us</h6>
          <div className="d-flex gap-4 flex-column flex-md-row">
            <div className="d-flex align-items-center gap-2">
              <div
                className="border border-warning rounded-circle d-flex align-items-center justify-content-center"
                style={{ width: "48px", height: "48px" }}
              >
                <Phone size={20} className="text-warning" />
              </div>
              <div>
                <p className="mb-0 small text-light">Tell Us</p>
                <p className="mb-0 fw-bold text-light">+94 771234567</p>
              </div>
            </div>
            <div className="d-flex align-items-center gap-2">
              <div
                className="border border-warning rounded-circle d-flex align-items-center justify-content-center"
                style={{ width: "48px", height: "48px" }}
              >
                <Mail size={20} className="text-warning" />
              </div>
              <div>
                <p className="mb-0 small text-light">Drop Mail</p>
                <p className="mb-0 fw-bold text-light">FindMe@gmail.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright + Scroll Top */}
      <div className="bg-dark text-center py-3 position-relative">
        <p className="mb-0 small text-secondary">
          © 2025 <span className="text-warning">FindMe</span> - All rights reserved.
        </p>
        <button
          onClick={scrollToTop}
          className="btn btn-warning btn-sm rounded-circle position-fixed bottom-3 end-3"
          style={{ width: "48px", height: "48px" }}
        >
          <ArrowUp size={20} />
        </button>
      </div>
      
    </footer>
  );
};

export default Footer;
